import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-soon-demo-not-active-tag',
  standalone: true,
  templateUrl: './soon-demo-not-active-tag.component.html',
  styleUrls: ['./soon-demo-not-active-tag.component.scss'],
})
export class SoonDemoNotActiveTagComponent {
  @Input() status: SoftwareStatus;
  @Input() divStyle: string;
  statusProps = STATUS_PROPS;

}

export type SoftwareStatus = 'soon' | 'demo' | 'request-demo' | 'ai';

export const STATUS_PROPS = {
  soon: {
    text: 'Coming soon',
  },
  demo: {
    text: 'DEMO',
  },
  'request-demo': {
    text: 'Request demo',
  },
};
